import React, { useState, useEffect, useMemo } from "react";
import CustomMap from "./CustomMap";
import { Translator } from "./translator";

const Support = () => {
  const { translateText, lang } = Translator();

  // --- All UI copy lives here (Italian source) --------------------------------
  const baseTextByLang = useMemo(
    () => ({
      it: {
        supportHeading: "Assistenza",
        supportDescription:
          "Se hai bisogno di informazioni, supporto o vuoi semplicemente metterti in contatto con noi",
        faqTitle: "FAQ",

        // Form
        formTitle: "Manda un messaggio",
        nameLabel: "Nome",
        emailLabel: "Email",
        phoneLabel: "Tel",
        messageLabel: "Messaggio",
        sendCta: "Invia",
        requiredNote:
          "* campi obbligatori. Inviando il modulo accetti l’uso dei dati per la gestione della richiesta.",
        translatingNotice: "Traduzione in corso…",
        submittingText: "Invio in corso…",

        // Validation
        valFillAll: "Per favore, compila tutti i campi obbligatori.",
        valEmail: "Per favore, inserisci un indirizzo email valido.",

        // FAQ (Italian)
        faq_1_q: "Che cos’è Te.C.H-e.?",
        faq_1_a:
          "Te.C.H-e. è l’acronimo di Technology for Cultural Heritage. Un progetto che ha lo scopo di preservare il Patrimonio Culturale Ereditario con l’ausilio di soluzioni innovative e tecnologie emergenti che garantiscano la fruizione avanzata del Patrimonio Culturale accessibile a tutti , la connettività con il resto del mondo, l’arricchimento dell’intrattenimento indoor grazie all’utilizzo dell’AI e nuove Tecnologie immersive.",
        faq_2_q: "A cosa serve la web/App Te.C.H-e.?",
        faq_2_a:
          "La web/App Te.C.H-e. è l’infrastruttura informatica del progetto Te.C.H-e. La piattaforma/App che reinventa l’Intrattenimento e il Turismo spostando l’attenzione da offerte e percorsi convenzionali verso esperienze uniche, autentiche, inclusive grazie alla potenza dell’Intelligenza Artificiale e di Tecniche Avanzate.",
        faq_3_q: "Che tipologia di tour posso acquistare?",
        faq_3_a:
          "Ci sono 3 tipologie di acquisto:\n" +
          "-  Acquisto singolo tour (€ 4.99)\n" +
          "-  Acquisto “pacchetto” che comprende la fruizione di 3 tour.\n" +
          "-  Acquisto piano abbonamento (BASIC con pubblicità/ PLUS senza pubblicità)\n\n" +
          "I tour sono divisi per regione e inoltre, in base agli interessi predominanti, sono inseriti in 5 categorie:\n" +
          "- Arte, creatività e ciack\n" +
          "- Archeologia, miti e leggende\n" +
          "- Borghi, tradizioni e memorie\n" +
          "- Feste, rituali e devozione\n" +
          "- Paesaggi, cibo e colture",

        faq_4_q: "In quali zone sono disponibili i tour?",
        faq_4_a:
          "Al momento sono disponibili tour in Campania (area Sannita, Costiera Sorrentina, Costiera Amalfitana, area Vesuviana, isola di Procida)",
        faq_5_q: "Non trovo il tour nella tipologia scelta, come posso fare?",
        faq_5_a:
          "Se non trovi il tour nella tipologia scelta, potrebbe essere che non sia disponibile o che la tipologia di riferimento sia ancora in aggiornamento. Prova ad utilizzare il selettore per area geografica o ad eliminare le spunte e godere di qualche tour affine.",
        faq_6_q: "Cosa mi permette di fare il tour?",
        faq_6_a:
          "Il tour permette a ognuno di vivere un’esperienza autentica e genuina. Ogni tour è creato ad hoc seguendo una narrazione sia territoriale che socioculturale di pratiche rurali, gastronomiche, artistiche, ecc… I tour sono costituiti da audioguida digitale visiva e auditiva arricchita da immagini reali, affascinanti video e coinvolgenti storytelling. Inoltre, grazie all’ausilio delle nuove Tecnologie, è possibile visualizzare esperienze immersive in 3D, AR e VR.",
        faq_7_q: "Come posso pianificare un tour?",
        faq_7_a:
          "Pianificare un tour è semplice, scegli il percorso più vicino ai tuoi interessi, acquistalo dal nostro sito web o dall’app TecheTour. Scadenza tour 30 giorni.",
        faq_8_q: "Come posso acquistare solo un tour?",
        faq_8_a:
          "Vai alla sezione “Tour digitali” e scegli l’opzione “singolo”. Seleziona il tour più adatto alle tue esigenze e più vicino ai tuoi interessi. Clicca su “acquista”, registrati e procedi al pagamento.",
        faq_9_q: "Come si utilizza il tour dopo averlo acquistato?",
        faq_9_a:
          "Fruire dei Tour di TecheTour è semplice! Clicca sul tour scelto e visualizza subito un’anteprima corredata da: titolo, sottotitolo, descrizione introduttiva, audio, foto, video e mappa geolocalizzata con le tappe di riferimento. Inoltre, cliccando sulle tappe del tour, è possibile visualizzare i relativi approfondimenti sempre corredati da audioguida e contenuti multimediali.\n" +
          "Tramite l’app si può accedere alle esperienza in 3D, AR e VR. Cliccando sulla tappa si visualizza l’esperienza disponibile, basta seguire le indicazioni dell’app per godere a pieno dell’intrattenimento TecheTour.",
        faq_10_q:
          "Da quando ho acquistato il tour, quanto tempo ho per attivarlo?",
        faq_10_a:
          "Una volta acquistato il tour TecheTour dal nostro sito web o dall’app TecheTour, si attiva automaticamente. Ricorda però che una volta attivato il  tour ha una scadenza di 30 giorni.",
        faq_11_q: "Come funziona il chatbot?",
        faq_11_a:
          "Il chatbot è facile ed intuitivo. Basta scrivere nel riquadro di messaggistica e l’Ai fornirà la risposta alle informazioni richieste. Qualora la risposta fornita non fosse esaustiva, è possibile contattarci direttamente alla mail : info@emozion-arti.com",
        faq_12_q: "Come posso fare per ricevere il rimborso?",
        faq_12_a:
          "I tour di TecheTour garantiscono la fruizione avanzata del Patrimonio Culturale accessibile a tutti poiché sono utilizzabili sia sul posto che comodamente da casa.",
        faq_13_q: "Come posso fare il reso di un tour digitale acquistato?",
        faq_13_a:
          "I tour digitali acquistati su TecheTour.it non sono soggetti a reso. Tuttavia, se il tour presenta problemi tecnici o di accesso, il cliente può contattarci per assistenza e risolveremo quanto prima. Per ulteriori domande o assistenza, non esitate a contattarci all'indirizzo email support@emozionarti.com. Grazie per la vostra collaborazione e comprensione.",
      },

      // TODO: replace EN/FR with your preferred wording.
      // For now, I’ll keep the same Italian content so the structure works.
      en: {
        supportHeading: "Support",
        supportDescription:
          "If you need information, support, or simply want to get in touch with us",
        faqTitle: "FAQ",

        formTitle: "Send a message",
        nameLabel: "Name",
        emailLabel: "Email",
        phoneLabel: "Phone",
        messageLabel: "Message",
        sendCta: "Send",
        requiredNote:
          "* required fields. By submitting the form, you accept the use of your data to manage your request.",
        translatingNotice: "Translating…",
        submittingText: "Sending…",

        valFillAll: "Please fill in all required fields.",
        valEmail: "Please enter a valid email address.",

        // For brevity: copy of IT text — you can translate each one later
        faq_1_q: "What is Te.C.H-e.?",
        faq_1_a:
          "Te.C.H-e. stands for Technology for Cultural Heritage. It is a project aimed at preserving Cultural Heritage using innovative solutions and emerging technologies that ensure advanced access to Cultural Heritage for everyone, global connectivity, and richer indoor entertainment through AI and immersive technologies.",
        faq_2_q: "What is the Te.C.H-e web/app for?",
        faq_2_a:
          "The Te.C.H-e web/app is the digital infrastructure of the Te.C.H-e project. It is the platform/app that reinvents Entertainment and Tourism by shifting the focus from conventional offers and routes towards unique, authentic, and inclusive experiences thanks to the power of Artificial Intelligence and Advanced Techniques.",
        faq_3_q: "What types of tours can I buy?",
        faq_3_a:
          "There are 3 purchase options:\n" +
          "- Single tour purchase (€ 4.99)\n" +
          "- “Package” purchase including access to 3 tours\n" +
          "- Subscription plan (BASIC with ads / PLUS without ads)\n\n" +
          "Tours are divided by region and, based on predominant interests, grouped into 5 categories:\n" +
          "- Art, creativity and cinema\n" +
          "- Archaeology, myths and legends\n" +
          "- Villages, traditions and memories\n" +
          "- Festivals, rituals and devotion\n" +
          "- Landscapes, food and crops",
        faq_4_q: "In which areas are the tours available?",
        faq_4_a:
          "Currently, tours are available in Campania (Sannio area, Sorrento Coast, Amalfi Coast, Vesuvian area, island of Procida).",
        faq_5_q:
          "I can’t find the tour in the chosen category, what can I do?",
        faq_5_a:
          "If you don’t find the tour in the selected category, it may not be available yet or that category is still being updated. Try using the geographic area selector or removing filters to discover related tours.",
        faq_6_q: "What does the tour allow me to do?",
        faq_6_a:
          "The tour allows everyone to live an authentic and genuine experience. Each tour is created ad hoc following a territorial and socio-cultural narrative of rural, gastronomic, artistic practices, etc. Tours consist of digital audio guides enriched with real images, fascinating videos, and engaging storytelling. Thanks to new technologies, you can also enjoy immersive 3D, AR and VR experiences.",
        faq_7_q: "How can I plan a tour?",
        faq_7_a:
          "Planning a tour is simple: choose the itinerary closest to your interests, purchase it from our website or from the TecheTour app. Tour expiry: 30 days.",
        faq_8_q: "How can I buy a single tour?",
        faq_8_a:
          'Go to the “Digital tours” section and choose the “single” option. Select the tour that best fits your needs and interests. Click "buy", register and proceed with payment.',
        faq_9_q: "How do I use the tour after purchasing it?",
        faq_9_a:
          "Using TecheTour’s tours is easy! Click on the chosen tour and immediately see a preview with: title, subtitle, introductory description, audio, photos, videos and a geolocalised map with the reference stops. By clicking on each stop, you can access extra content with audio guides and multimedia content.\n" +
          "Through the app, you can access 3D, AR and VR experiences. Click on a stop to open the available experience and follow the app’s instructions to fully enjoy TecheTour entertainment.",
        faq_10_q:
          "Once I’ve purchased a tour, how long do I have to activate it?",
        faq_10_a:
          "Once you purchase a TecheTour tour via the website or the TecheTour app, it is activated automatically. Remember that once activated, the tour is valid for 30 days.",
        faq_11_q: "How does the chatbot work?",
        faq_11_a:
          "The chatbot is simple and intuitive. Just write in the message box and the AI will provide answers to your questions. If the answer is not sufficient, you can contact us directly at: info@emozion-arti.com",
        faq_12_q: "How can I get a refund?",
        faq_12_a:
          "TecheTour tours ensure advanced access to Cultural Heritage for everyone, since they can be used on-site or comfortably from home.",
        faq_13_q:
          "How can I return a digital tour that I have purchased?",
        faq_13_a:
          "Digital tours purchased on TecheTour.it cannot be returned. However, if the tour has technical or access issues, you can contact us for assistance and we will resolve them as soon as possible. For further questions or support, feel free to contact us at support@emozionarti.com. Thank you for your understanding.",
      },

      fr: {
        supportHeading: "Assistance",
        supportDescription:
          "Si vous avez besoin d’informations, de support ou que vous souhaitez simplement nous contacter",
        faqTitle: "FAQ",

        formTitle: "Envoyer un message",
        nameLabel: "Nom",
        emailLabel: "Email",
        phoneLabel: "Téléphone",
        messageLabel: "Message",
        sendCta: "Envoyer",
        requiredNote:
          "* champs obligatoires. En envoyant ce formulaire, vous acceptez l’utilisation de vos données pour la gestion de votre demande.",
        translatingNotice: "Traduction en cours…",
        submittingText: "Envoi en cours…",

        valFillAll: "Veuillez remplir tous les champs obligatoires.",
        valEmail: "Veuillez saisir une adresse email valide.",

        // Again, French FAQ text here – you can refine later if you want
        faq_1_q: "Qu’est-ce que Te.C.H-e. ?",
        faq_1_a:
          "Te.C.H-e. signifie Technology for Cultural Heritage. C’est un projet visant à préserver le patrimoine culturel grâce à des solutions innovantes et des technologies émergentes qui garantissent un accès avancé au patrimoine culturel pour tous, une connectivité mondiale et un divertissement indoor enrichi grâce à l’IA et aux technologies immersives.",
        faq_2_q: "À quoi sert le site / l’app Te.C.H-e. ?",
        faq_2_a:
          "Le site / l’app Te.C.H-e. est l’infrastructure numérique du projet Te.C.H-e. C’est la plateforme / l’application qui réinvente le divertissement et le tourisme en déplaçant l’attention des offres et itinéraires conventionnels vers des expériences uniques, authentiques et inclusives, grâce à la puissance de l’Intelligence Artificielle et de techniques avancées.",
        faq_3_q: "Quel type de tours puis-je acheter ?",
        faq_3_a:
          "Il existe 3 types d’achats :\n" +
          "- Achat d’un tour unique (4,99 €)\n" +
          "- Achat d’un “pack” comprenant 3 tours\n" +
          "- Achat d’un abonnement (BASIC avec publicité / PLUS sans publicité)\n\n" +
          "Les tours sont divisés par région et, selon les intérêts prédominants, répartis en 5 catégories :\n" +
          "- Art, créativité et cinéma\n" +
          "- Archéologie, mythes et légendes\n" +
          "- Villages, traditions et mémoires\n" +
          "- Fêtes, rituels et dévotion\n" +
          "- Paysages, gastronomie et cultures",
        faq_4_q: "Dans quelles zones les tours sont-ils disponibles ?",
        faq_4_a:
          "Actuellement, des tours sont disponibles en Campanie (zone du Sannio, Côte de Sorrente, Côte Amalfitaine, zone du Vésuve, île de Procida).",
        faq_5_q:
          "Je ne trouve pas le tour dans la catégorie choisie, que puis-je faire ?",
        faq_5_a:
          "Si vous ne trouvez pas le tour dans la catégorie sélectionnée, il se peut qu’il ne soit pas encore disponible ou que cette catégorie soit en cours de mise à jour. Essayez d’utiliser le filtre par zone géographique ou de supprimer certains filtres pour découvrir d’autres tours similaires.",
        faq_6_q: "Que permet de faire le tour ?",
        faq_6_a:
          "Le tour permet à chacun de vivre une expérience authentique et sincère. Chaque tour est créé sur mesure en suivant un récit territorial et socioculturel de pratiques rurales, gastronomiques, artistiques, etc. Les tours sont composés de guides audio numériques enrichis d’images réelles, de vidéos fascinantes et de récits immersifs. Grâce aux nouvelles technologies, vous pouvez également vivre des expériences en 3D, AR et VR.",
        faq_7_q: "Comment puis-je planifier un tour ?",
        faq_7_a:
          "Planifier un tour est simple : choisissez l’itinéraire le plus proche de vos intérêts, achetez-le sur notre site ou via l’app TecheTour. Le tour est valable 30 jours.",
        faq_8_q: "Comment acheter un seul tour ?",
        faq_8_a:
          "Rendez-vous dans la section « Tours numériques » et choisissez l’option « simple ». Sélectionnez le tour qui correspond le mieux à vos besoins et à vos intérêts. Cliquez sur « acheter », inscrivez-vous et procédez au paiement.",
        faq_9_q: "Comment utiliser le tour après l’achat ?",
        faq_9_a:
          "Profiter des tours TecheTour est simple ! Cliquez sur le tour choisi et visualisez immédiatement un aperçu avec : titre, sous-titre, description introductive, audio, photos, vidéos et une carte géolocalisée avec les étapes du parcours. En cliquant sur chaque étape, vous pouvez accéder à des contenus supplémentaires avec guide audio et contenus multimédias.\n" +
          "Via l’application, vous pouvez accéder aux expériences en 3D, AR et VR. Cliquez sur l’étape pour afficher l’expérience disponible et suivez les indications de l’app pour profiter pleinement du divertissement TecheTour.",
        faq_10_q:
          "Une fois le tour acheté, combien de temps ai-je pour l’activer ?",
        faq_10_a:
          "Une fois le tour TecheTour acheté sur notre site ou via l’app TecheTour, il s’active automatiquement. N’oubliez pas qu’une fois activé, le tour est valable 30 jours.",
        faq_11_q: "Comment fonctionne le chatbot ?",
        faq_11_a:
          "Le chatbot est simple et intuitif. Il suffit d’écrire dans la zone de message et l’IA fournira la réponse à vos questions. Si la réponse n’est pas suffisante, vous pouvez nous contacter directement à l’adresse : info@emozion-arti.com",
        faq_12_q: "Comment puis-je obtenir un remboursement ?",
        faq_12_a:
          "Les tours TecheTour garantissent un accès avancé au patrimoine culturel à tous, car ils peuvent être utilisés sur place ou confortablement depuis chez soi.",
        faq_13_q:
          "Comment puis-je retourner un tour numérique acheté ?",
        faq_13_a:
          "Les tours numériques achetés sur TecheTour.it ne sont pas soumis au droit de retour. Toutefois, si le tour présente des problèmes techniques ou d’accès, vous pouvez nous contacter pour obtenir de l’aide et nous résoudrons le problème dans les plus brefs délais. Pour toute autre question ou assistance, écrivez-nous à support@emozionarti.com. Merci de votre compréhension.",
      },
    }),
    []
  );

  // Build FAQ from baseText keys
  const baseFAQ = useMemo(
    () => [
      { q: "faq_1_q", a: "faq_1_a" },
      { q: "faq_2_q", a: "faq_2_a" },
      { q: "faq_3_q", a: "faq_3_a" },
      { q: "faq_4_q", a: "faq_4_a" },
      { q: "faq_5_q", a: "faq_5_a" },
      { q: "faq_6_q", a: "faq_6_a" },
      { q: "faq_7_q", a: "faq_7_a" },
      { q: "faq_8_q", a: "faq_8_a" },
      { q: "faq_9_q", a: "faq_9_a" },
      { q: "faq_10_q", a: "faq_10_a" },
      { q: "faq_11_q", a: "faq_11_a" },
      { q: "faq_12_q", a: "faq_12_a" },
      { q: "faq_13_q", a: "faq_13_a" },
    ],
    []
  );

  // --- Local state ------------------------------------------------------------
  const [openIndex, setOpenIndex] = useState(null);
  const [t, setT] = useState(baseTextByLang.it); // translated UI text
  const [translatedFAQ, setTranslatedFAQ] = useState([]);
  const [isTranslating, setIsTranslating] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  // Translate everything on language change
  useEffect(() => {
    let alive = true;
    setIsTranslating(true);

    const activeBase = baseTextByLang[lang] || baseTextByLang.it;

    // 1️⃣ For it / en / fr → use static copy, no Translator API
    if (lang === "it" || lang === "en" || lang === "fr") {
      const faqLocal = baseFAQ.map((row) => ({
        question: activeBase[row.q],
        answer: activeBase[row.a],
      }));

      if (alive) {
        setT(activeBase);
        setTranslatedFAQ(faqLocal);
        setIsTranslating(false);
      }
      return () => {
        alive = false;
      };
    }

    // 2️⃣ For all other languages → translate from Italian base
    (async () => {
      try {
        const source = baseTextByLang.it;
        const entries = Object.entries(source);

        const translatedEntries = await Promise.all(
          entries.map(async ([k, v]) => {
            if (!v) return [k, v];
            const out = await translateText(v);
            return [k, out || v];
          })
        );

        const dict = Object.fromEntries(translatedEntries);

        const faq = baseFAQ.map((row) => ({
          question: dict[row.q],
          answer: dict[row.a],
        }));

        if (!alive) return;
        setT(dict);
        setTranslatedFAQ(faq);
        setIsTranslating(false);
      } catch (e) {
        if (!alive) return;
        // Fallback to Italian if translation fails
        const faqLocal = baseFAQ.map((row) => ({
          question: baseTextByLang.it[row.q],
          answer: baseTextByLang.it[row.a],
        }));
        setT(baseTextByLang.it);
        setTranslatedFAQ(faqLocal);
        setIsTranslating(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [lang, baseTextByLang, baseFAQ, translateText]);

  const toggleFAQ = (index) => setOpenIndex((prev) => (prev === index ? null : index));

  // Basic client-side validation + “submitting” state for better UX
  const onValidateAndSubmit = (e) => {
    const form = e.currentTarget;
    const email = form.email?.value?.trim();
    const name = form.name?.value?.trim();
    const message = form.message?.value?.trim();

    if (!name || !email || !message) {
      e.preventDefault();
      alert(t.valFillAll);
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(email)) {
      e.preventDefault();
      alert(t.valEmail);
      return;
    }

    setSubmitting(true); // allow native submit to formsubmit.co
  };

  return (
    <div className="w-full">
      {/* HERO / CONTACT + MAP */}
      <section className="bg-[#324B8E] text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">
            {/* Left: copy + contacts */}
            <div className="flex flex-col justify-between">
              <div className="space-y-6">
                <h1 className="font-bold tracking-tight text-[clamp(2rem,4vw,3rem)] leading-tight">
                  {t.supportHeading}
                </h1>
                <p className="font-medium text-[clamp(1.05rem,1.5vw,1.35rem)] leading-relaxed opacity-95">
                  {t.supportDescription}
                </p>
              </div>

              <div className="mt-8 space-y-5 text-sm sm:text-base">
                <ContactItem
                  icon="email"
                  lines={["assistenza@techetour.it", "info@techetour.it"]}
                />
                <ContactItem icon="phone" lines={["(+39) 333 806 5959", "(+39) 081 424 4274"]} />
                <ContactItem
                  icon="location"
                  lines={["Via Giuseppe Verdi, 46", "Pomigliano d’Arco (NA), Italia"]}
                />
              </div>
            </div>

            {/* Right: map (keeps aspect on small screens) */}
            <div className="w-full">
              <div className="relative w-full overflow-hidden rounded-xl shadow-lg">
                <div className="aspect-[16/12] sm:aspect-[16/10] lg:aspect-[16/9]">
                  <div className="absolute inset-0">
                    <CustomMap />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {isTranslating && <p className="mt-3 text-xs opacity-80">{t.translatingNotice}</p>}
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-[#f5f7fb]">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
          <h2 className="text-center font-bold text-[clamp(1.5rem,2.5vw,2rem)] text-gray-900">
            {t.faqTitle}
          </h2>

          <div className="mt-8 sm:mt-10 space-y-4">
            {translatedFAQ.map((item, index) => (
              <FAQItem
                key={index}
                index={index}
                openIndex={openIndex}
                onToggle={toggleFAQ}
                question={item.question}
                answer={item.answer}
              />
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT FORM */}
      <section className="bg-[#f5f7fb]">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-12">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8">
            <h2 className="text-[clamp(1.25rem,2.2vw,1.75rem)] font-bold text-gray-900">
              {t.formTitle}
            </h2>

            <form
              className="mt-8"
              method="POST"
              action="https://formsubmit.co/emozionartisrl@gmail.com"
              onSubmit={onValidateAndSubmit}
            >
              {/* formsubmit options */}
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_template" value="table" />
              {/* <input type="hidden" name="_next" value="https://techetour.it/thank-you" /> */}

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
                <InputField label={`${t.nameLabel} *`} name="name" type="text" required />
                <InputField label={`${t.emailLabel} *`} name="email" type="email" required />
                <InputField label={t.phoneLabel} name="phone" type="text" />
              </div>

              <div className="mt-4 sm:mt-6">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                  {t.messageLabel} *
                </label>
                <textarea
                  className="form-input w-full rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 min-h-[7rem] sm:min-h-[9rem] p-3"
                  id="message"
                  name="message"
                  required
                />
              </div>

              <button
                type="submit"
                disabled={submitting}
                className="mt-6 bg-[#324B8E] text-white w-full h-10 rounded"
              >
                {submitting ? t.submittingText : t.sendCta}
              </button>
            </form>

            <p className="mt-3 text-xs text-gray-500">{t.requiredNote}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

/* -------------------------------- Components ------------------------------- */

const ContactItem = ({ icon, lines }) => {
  const icons = {
    email: (
      <svg
        className="w-5 h-5 sm:w-6 sm:h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="M3 7l9 6 9-6" />
      </svg>
    ),
    phone: (
      <svg
        className="w-5 h-5 sm:w-6 sm:h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M22 16.92V19a3 3 0 0 1-3.28 3A19.5 19.5 0 0 1 3 6.28 3 3 0 0 1 6 3h2.09a2 2 0 0 1 2 1.72c.12.81.31 1.6.58 2.35a2 2 0 0 1-.45 2.11L9 10.5a16 16 0 0 0 4.5 4.5l1.32-1.22a2 2 0 0 1 2.11-.45c.75.27 1.54.46 2.35.58A2 2 0 0 1 22 16.92Z" />
      </svg>
    ),
    location: (
      <svg
        className="w-5 h-5 sm:w-6 sm:h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M12 21s-7-7.5-7-12a7 7 0 1 1 14 0c0 4.5-7 12-7 12Z" />
        <circle cx="12" cy="9" r="2.5" />
      </svg>
    ),
  };

  return (
    <div className="flex gap-4 items-start text-white/95">
      <div className="h-10 w-10 flex items-center justify-center bg-white/10 rounded-lg">
        {icons[icon]}
      </div>
      <div className="leading-tight space-y-1">
        {lines.map((line, i) => (
          <p key={i} className="text-sm sm:text-base">
            {line}
          </p>
        ))}
      </div>
    </div>
  );
};

const FAQItem = ({ index, openIndex, onToggle, question, answer }) => {
  const isOpen = openIndex === index;
  const panelId = `faq-panel-${index}`;
  const buttonId = `faq-button-${index}`;

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onToggle(index);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100">
      <div
        id={buttonId}
        role="button"
        tabIndex={0}
        aria-controls={panelId}
        aria-expanded={isOpen}
        onClick={() => onToggle(index)}
        onKeyDown={onKeyDown}
        className="px-4 sm:px-6 py-4 sm:py-5 flex justify-between items-center cursor-pointer"
      >
        <span className="text-base sm:text-lg font-medium text-gray-900">{question}</span>
        <span
          className="ml-4 inline-flex h-8 w-8 items-center justify-center rounded-full border border-gray-300 text-gray-700 select-none"
          aria-hidden="true"
        >
          {isOpen ? "−" : "+"}
        </span>
      </div>

      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        className={`${
          isOpen ? "block" : "hidden"
        } px-4 sm:px-6 pb-5 text-sm sm:text-[0.9375rem] leading-relaxed text-gray-700 whitespace-pre-line`}
      >
        {answer}
      </div>
    </div>
  );
};

const InputField = ({ label, name, type, required }) => (
  <div className="form-wrap">
    <label htmlFor={name} className="block text-sm font-medium text-gray-700 mb-1">
      {label}
    </label>
    <input
      className="form-input w-full rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 px-3 py-2"
      id={name}
      type={type}
      name={name}
      required={required}
      autoComplete={name}
      inputMode={type === "email" ? "email" : undefined}
    />
  </div>
);

export default Support;
